
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credlixremit",
      function () {
        return require("private-next-pages/credlixremit/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/credlixremit"])
      });
    }
  